import {
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class ResetUserPasswordRPC implements
  LeoRPC<ResetUserPasswordRPC.Request, ResetUserPasswordRPC.Response, ResetUserPasswordRPC.Errors.Errors>
{
  abstract execute(
    request: ResetUserPasswordRPC.Request
  ): Promise<LeoRPCResult<ResetUserPasswordRPC.Response, ResetUserPasswordRPC.Errors.Errors>>;
}

export namespace ResetUserPasswordRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isResetUserPasswordRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `ResetUserPasswordRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `ResetUserPasswordRPC.Response()`;
  };

  export enum RPCError {
    SendEmailFailed = "SEND_EMAIL_FAILED",
    ResetPasswordLimitReached = "RESET_PASSWORD_LIMIT_REACHED",
    EmailAlreadySent = "EMAIL_ALREADY_SENT"
  }

  export namespace Errors {
    
    export interface SendEmailFailedDTO {
      code: string;
    }
    
    export class SendEmailFailed extends LeoRPCError<RPCError> {
      readonly isSendEmailFailed: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.SendEmailFailed;
        super(code);
      }
    
    
      toDTO(): SendEmailFailedDTO {
        const dto: SendEmailFailedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    SendEmailFailed.prototype.toString = function toString(): string {
      return `ResetUserPasswordRPC.SEND_EMAIL_FAILED()`;
    };
    
    
    export interface ResetPasswordLimitReachedDTO {
      code: string;
    }
    
    export class ResetPasswordLimitReached extends LeoRPCError<RPCError> {
      readonly isResetPasswordLimitReached: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.ResetPasswordLimitReached;
        super(code);
      }
    
    
      toDTO(): ResetPasswordLimitReachedDTO {
        const dto: ResetPasswordLimitReachedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    ResetPasswordLimitReached.prototype.toString = function toString(): string {
      return `ResetUserPasswordRPC.RESET_PASSWORD_LIMIT_REACHED()`;
    };
    
    
    export interface EmailAlreadySentDTO {
      code: string;
    }
    
    export class EmailAlreadySent extends LeoRPCError<RPCError> {
      readonly isEmailAlreadySent: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.EmailAlreadySent;
        super(code);
      }
    
    
      toDTO(): EmailAlreadySentDTO {
        const dto: EmailAlreadySentDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    EmailAlreadySent.prototype.toString = function toString(): string {
      return `ResetUserPasswordRPC.EMAIL_ALREADY_SENT()`;
    };
    

    export type Errors = SendEmailFailed | ResetPasswordLimitReached | EmailAlreadySent;
    export type ErrorsDTO = SendEmailFailedDTO | ResetPasswordLimitReachedDTO | EmailAlreadySentDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.SendEmailFailed:
          return new SendEmailFailed();
        case RPCError.ResetPasswordLimitReached:
          return new ResetPasswordLimitReached();
        case RPCError.EmailAlreadySent:
          return new EmailAlreadySent();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}



export class InvalidResponseSendEmailFailedError extends ResetUserPasswordRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSendEmailFailedError";
  }
}

export class InvalidResponseResetPasswordLimitReachedError extends ResetUserPasswordRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseResetPasswordLimitReachedError";
  }
}

export class InvalidResponseEmailAlreadySentError extends ResetUserPasswordRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseEmailAlreadySentError";
  }
}

